import React from "react";
import Header from "../Header";
import Banner from "../Banner";
import RegisterForm from "../Register/RegisterForm";
import Footer from "../../Footer";
import ControlledAccordions from "../ControlledAccordions";

function Register() {
  return (
    <div>
      <Header />
      <hr
        style={{
          width: "95%",
          marginTop: "-30px",
          marginBottom: "30px",
          height: "2px",
          marginLeft: "2.5%",
        }}
      />
      <Banner />
      <ControlledAccordions />
      <RegisterForm />
      <Footer />
    </div>
  );
}

export default Register;
